import TextField from '@material-ui/core/TextField';
import { navigate } from 'gatsby';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { HiOutlineCheckCircle } from 'react-icons/hi';
import ButtonCta from '@atoms/ButtonCta/ButtonCta';
import Divider from '@atoms/Divider/Divider';
import HeroIcon from '@atoms/HeroIcon/HeroIcon';
import Text from '@atoms/Text/Text';
import './_MailchimpForm.scss';
import { useTranslation } from 'react-i18next';
import useLocale from '@hooks/useLocale';

const MailchimpForm = ({ successType, cta, align, MCFrom = 'other' }) => {
    const { t } = useTranslation();
    const { currentLanguage } = useLocale();
    const [data, setData] = useState({
        mType: '',
        email: '',
        result: null,
        myMsg: '',
        inlineSuccess: false,
    });

    const mod_class = [
        'MailchimpForm',
        align !== undefined ? 'align-' + align : '',
    ].join(' ');

    const base_endPoint =
        'https://aepsy.us17.list-manage.com/subscribe/post?u=61cbde422266875a1eaf1b26b&amp;id=8eb558d9bb';

    const custom_endPoint = base_endPoint + '&SIGNUP=' + MCFrom;

    const _handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await addToMailchimp(
                data.email,
                {},
                custom_endPoint
            )
            if (res.result === 'success') {
                // show success
                setData({ ...data, result: res.result, myMsg: res.msg });

                if (successType === 'inline') {
                    setData({ ...data, inlineSuccess: true });
                } else {
                    if (MCFrom === 'business') {
                        navigate(`/${currentLanguage}/business-demo-requested`);
                    } else if (MCFrom === 'coaching') {
                        navigate(`/${currentLanguage}/coaching-signup`);
                    } else {
                        navigate(`/${currentLanguage}/on-the-waitinglist`);
                    }
                }
            } else {
                // show failure
                setData({ ...data, result: res.result, myMsg: res.msg });
            }
        } catch (e) {
            console.log(e?.message);
        }
    };

    const handleChange = (event) => {
        setData({ ...data, email: event.target.value });
    };

    return (
        <div>
            {data.inlineSuccess === false ? (
                <>
                    <form className={mod_class} onSubmit={_handleSubmit}>
                        <TextField
                            id="outlined-email-input"
                            label={t('mailchimp.form.label')}
                            type="email"
                            name="EMAIL"
                            autoComplete="email"
                            variant="outlined"
                            onChange={handleChange}
                        />

                        <ButtonCta
                            id="mc-embedded-subscribe"
                            name="signup_submit"
                            label={cta}
                            type="primary"
                            goal="submit"
                        />
                    </form>
                    <Text size="xs" align={align ? align : 'left'}>
                        {t('mailchimp.form.privacy')}{' '}
                    </Text>
                    {data.result && (
                        <div className={'Mailchimp_InfoBox ' + data.result}>
                            <div className="Mailchimp_InfoBox--inner">
                                {ReactHtmlParser(data.myMsg)}
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <Divider spacing="xs" invisible />
                    <HeroIcon size="m" theme="success" align="center">
                        <HiOutlineCheckCircle />
                    </HeroIcon>
                </>
            )}
        </div>
    );
};

export default MailchimpForm;
